export default __webpack_public_path__ + "static/media/vinmonopolet.461cc595.png";